/*
 * Author: Harper Yan
 * File Created: Monday, 25-03-17 10:15 am
 * Last Modified: Monday, 25-06-30 10:16 am, by Dw
 */
/* eslint-disable no-unused-vars -- ignore  */

import { getEnv } from '@web/utils';

declare global {
  interface Window {
    decardAndroid?: {
      postMessage?: (_message: string) => void;
    };
    webkit?: {
      messageHandlers?: {
        decardIOS?: {
          postMessage?: (_message: string) => void;
        };
      };
    };
  }
}

export { getOpenApiSession } from '@/src/middlewares/stores/open-api/utils';

export const DEFAULT_OPEN_API_ERROR_PATHNAME = '/open-api-error';

const DEFAULT_OPEN_API_ERROR_HOST =
  getEnv() === 'local'
    ? 'http://localhost:3000'
    : process.env.NEXT_PUBLIC_SITE_HOST;

export const DEFAULT_ERROR_URL = `${DEFAULT_OPEN_API_ERROR_HOST}${process.env.NEXT_PUBLIC_PREFIX_PATH}${DEFAULT_OPEN_API_ERROR_PATHNAME}`;

export const USE_CUSTOM_ERROR_PAGE: string[] = [];

export enum OPENAPI_POST_MESSAGE_TYPE {
  DECARD_OPENAPI_CLOSE = 'DECARD_OPENAPI_CLOSE',
  DECARD_OPENAPI_MFA_OPENED = 'DECARD_OPENAPI_MFA_OPENED',
  DECARD_OPENAPI_CARD_DETAIL_OPENED = 'DECARD_OPENAPI_CARD_DETAIL_OPENED',
}

const checkOpenAPI = () => {
  return process.env.NEXT_PUBLIC_APP_NAME === 'openapi';
};

export const isOpenApi = checkOpenAPI();

export const isNativeApp = () => {
  if (typeof window === 'undefined') return false;

  return Boolean(
    /DeCard/i.test(window.navigator.userAgent) ||
      window.decardAndroid ||
      window.webkit?.messageHandlers?.decardIOS,
  );
};

export const postNativeOpenAPIMessage = (
  name: OPENAPI_POST_MESSAGE_TYPE,
  payload?: Record<string, unknown> | null,
) => {
  if (typeof window === 'undefined' || !isOpenApi) return;

  if (!isNativeApp()) {
    window.parent.postMessage({ name, payload: payload ?? null }, '*');

    return;
  }

  // for appSdk
  const jsonStr = JSON.stringify({
    name,
    payload: payload ?? null,
  });

  window.decardAndroid?.postMessage?.(jsonStr);

  // eslint-disable-next-line @typescript-eslint/dot-notation -- ignore
  window.webkit?.messageHandlers?.['decardIOS']?.postMessage?.(jsonStr);
};
